import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { OrganizeComponent } from './components/organize/organize.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { UiModule } from 'src/app/ui/ui.module';



@NgModule({
  declarations: [
    OrganizeComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
    UiModule,
  ]
})
export class OrganizeModule { }
